import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowDown } from "lucide-react";
export default function DebattensCentrum() {
  const tickerItems = ["MILITÆR DISCIPLIN ER FUNDAMENTET", "KRISTEN ETIK I CENTRUM", "KARAKTERDANNELSE GENNEM KAMP", "OPGØR MED HYKLERI", "PERSONLIGT ANSVAR ELLER KAOS", "SAMFUNDSDEBAT UDEN FILTER", "TRO & EKSISTENS ER IKKE PRIVAT", "DISCIPLIN & KARAKTERSTYRKE", "SAMFUND & MORAL SKAL GENREJSES", "DE UFØDTES RETTIGHEDER", "GARDERENS PLIGTFØLELSE"];
  return <section id="debattens-centrum" className="dark bg-background text-foreground relative w-full overflow-hidden border-b-2 border-border py-32 md:py-48">
      {}
      <div className="absolute inset-0 z-0 flex flex-col justify-center opacity-10 select-none pointer-events-none overflow-hidden">
        {}
        <div className="flex whitespace-nowrap py-4" style={{
        transform: "rotate(-2deg) scale(1.1)"
      }}>
          <div className="animate-marquee flex gap-8 text-6xl md:text-8xl font-black uppercase tracking-tighter text-muted-foreground/50">
            {tickerItems.map((item, i) => <span key={`r1-${i}`} data-index={i}>{item}</span>)}
            {tickerItems.map((item, i) => <span key={`r1-dup-${i}`} data-index={i + tickerItems.length}>{item}</span>)}
          </div>
        </div>
        
        {}
        <div className="flex whitespace-nowrap py-4" style={{
        transform: "rotate(-2deg) scale(1.1)"
      }}>
          <div className="animate-marquee-reverse flex gap-8 text-6xl md:text-8xl font-black uppercase tracking-tighter text-muted-foreground/50">
             {tickerItems.slice().reverse().map((item, i) => <span key={`r2-${i}`} data-index={i}>{item}</span>)}
            {tickerItems.slice().reverse().map((item, i) => <span key={`r2-dup-${i}`} data-index={i + tickerItems.length}>{item}</span>)}
          </div>
        </div>

         {}
         <div className="flex whitespace-nowrap py-4" style={{
        transform: "rotate(-2deg) scale(1.1)"
      }}>
          <div className="animate-marquee flex gap-8 text-6xl md:text-8xl font-black uppercase tracking-tighter text-muted-foreground/50">
            {tickerItems.map((item, i) => <span key={`r3-${i}`} data-index={i}>{item}</span>)}
            {tickerItems.map((item, i) => <span key={`r3-dup-${i}`} data-index={i + tickerItems.length}>{item}</span>)}
          </div>
        </div>
      </div>

      {}
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-background via-transparent to-background pointer-events-none" />
      <div className="absolute inset-0 z-0 bg-radial-[circle_at_center] from-transparent to-background/80 pointer-events-none" />

      {}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <div className="inline-block border-2 border-primary bg-background/90 px-4 py-1 mb-6 backdrop-blur-sm">
          <span className="text-sm font-mono tracking-widest uppercase text-primary font-bold">
            Officielt Arkiv
          </span>
        </div>

        <h1 className="font-serif text-6xl md:text-8xl lg:text-9xl font-black tracking-tighter leading-none mb-6 text-foreground drop-shadow-2xl">
          FRONTLINJEN
        </h1>

        <p className="max-w-2xl mx-auto text-lg md:text-xl text-muted-foreground font-serif italic mb-10 leading-relaxed">
          "Christian Bak fører en nådesløs samfundsdebat, hvor militær disciplin og kristen etik danner værn mod tidsåndens forfald. 
          Gennem et fundamentalt opgør med hykleri og fokus på karakterdannelse, forenes Samfund & Moral, Disciplin & Karakterstyrke samt Tro & Eksistens i et krav om personligt ansvar."
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="h-14 px-8 text-lg font-bold uppercase tracking-wider border-2 border-primary bg-primary text-primary-foreground hover:bg-primary/90 rounded-none">
            <Link to="#seneste-indlaeg">
              Læs Seneste Indlæg
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="h-14 px-8 text-lg font-bold uppercase tracking-wider border-2 border-muted-foreground text-foreground hover:bg-accent hover:text-accent-foreground rounded-none bg-transparent backdrop-blur-sm">
            <Link to="/ContactPage">
              Start Debatten
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <ArrowDown className="w-8 h-8 text-muted-foreground opacity-50" />
      </div>

      {}
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes marquee-reverse {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
        .animate-marquee {
          animation: marquee 60s linear infinite;
        }
        .animate-marquee-reverse {
          animation: marquee-reverse 60s linear infinite;
        }
      `}</style>
    </section>;
}